import React from 'react';
import { DomHelpers } from '@salesperformanceint/e4shared';
import Toggle from 'components/prism/toggle';

export const ButtonGroup = ({ options, option, setOption, loading }) => {
    const loaded = React.useRef(null);

    const resizeHandler = () => {
        const containers = document.getElementsByClassName('prism-metric-score-value');
        [...containers].map(x => DomHelpers.shrinkFont('label-text-fit', 32, x));
    };

    React.useEffect(() => {
        window.addEventListener('resize', resizeHandler);

        return () => {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);

    React.useEffect(() => {
        if (loaded?.current) {
            resizeHandler();
        }
    }, [loaded?.current, loading]);

    return (
        <div ref={loaded}>
            <div className="two-col flex flex-center mb10">
                <div className="text-left">
                    <Toggle value={option} onChange={setOption}>
                        {options.map(({ key, text }) => (
                            <button key={key} value={key}>
                                {text}
                            </button>
                        ))}
                    </Toggle>
                </div>
            </div>
        </div>
    );
};

export default ButtonGroup;
